var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "registration-details" },
    [
      _c("div", [
        _c(
          "h2",
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("support.registrationDetails.header"))
            ),
            _c("setup-state", {
              attrs: { setupStatus: _vm.registration.setupStatus }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ct-row" }, [
          _c("div", { staticClass: "product" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$t("support.table.product")))]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-group" }, [
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [_vm._v(_vm._s(_vm.$t("support.table.product")))])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.product))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contact-infos" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("support.registrationDetails.contactData")))
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-group" }, [
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("support.registrationDetails.name")))
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("appellation." + _vm.registration.appellation)
                    ) +
                      " " +
                      _vm._s(_vm.registration.firstName) +
                      "\n                            " +
                      _vm._s(_vm.registration.lastName)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("support.registrationDetails.email")))
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.email))
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href:
                        "https://support.church.tools/search/?q=" +
                        _vm.registration.email
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("support.registrationDetails.linkfreescout")
                      )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("support.registrationDetails.phone")))
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.phone))
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("support.registrationDetails.registerLanguage")
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.registrationLanguage))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "church-infos" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("support.registrationDetails.churchData")))
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-group" }, [
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.churchName"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.churchName))
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("support.registrationDetails.city")))
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.city))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "title left-margin" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.country"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.countryCode))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "title left-margin" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.baseLanguage"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.baseLanguage))
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.instanceName"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    "https://" +
                      _vm._s(_vm.registration.siteName) +
                      ".church.tools"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.website"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.website))
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ct-row" }, [
          _c("div", { staticClass: "infos" }, [
            _c("h3", [
              _vm._v(
                _vm._s(_vm.$t("support.registrationDetails.furtherInformation"))
              )
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-group" }, [
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.heardFrom"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.heardFrom))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "title left-margin" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.discount"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.discountCode))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "title left-margin" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("support.registrationDetails.cta")))
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.cta))
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.infomails"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.infomails))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "title left-margin" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.newsletter"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.newsletter))
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.license"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.licenseKey))
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.created"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm._f("formatDate")(_vm.registration.created)))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "title left-margin" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.lastupdate"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(_vm._f("formatDate")(_vm.registration.last_update))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "list-group-item" }, [
                _c("span", { staticClass: "title" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("support.registrationDetails.userAgent"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.registration.userAgent))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "logs" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("support.registrationDetails.logs")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "panel-group",
                attrs: {
                  id: "accordion",
                  role: "tablist",
                  "aria-multiselectable": "true"
                }
              },
              _vm._l(_vm.registration.logs, function(log, index) {
                return _c("div", { staticClass: "panel panel-default" }, [
                  _c(
                    "div",
                    {
                      staticClass: "panel-heading",
                      attrs: { role: "tab", id: "headingOne" }
                    },
                    [
                      _c("h4", { staticClass: "panel-title" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              role: "button",
                              "data-toggle": "collapse",
                              "data-parent": "#accordion",
                              href: "#collapse-" + index,
                              "aria-expanded": "true",
                              "aria-controls": "collapseOne"
                            }
                          },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm._f("formatDate")(log.created)) + ":"
                              )
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(log.message) +
                                "\n                                "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "panel-collapse collapse",
                      attrs: { id: "collapse-" + index, role: "tabpanel" }
                    },
                    [
                      _c("div", { staticClass: "panel-body" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(log.details) +
                            "\n                            "
                        )
                      ])
                    ]
                  )
                ])
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ct-action" }, [
          _c("div", { staticClass: "ct-row two-elements" }, [
            _c("div", [
              _c("label", { attrs: { for: "comment" } }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("support.registrationDetails.comment")) +
                    "\n                    "
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.comment,
                    expression: "comment"
                  }
                ],
                attrs: { name: "comment", type: "text", id: "comment" },
                domProps: { value: _vm.comment },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.comment = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  on: {
                    click: function($event) {
                      return _vm.addComment()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("support.registrationDetails.addcomment")) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.correspondingTab === "error" ||
              _vm.correspondingTab === "pending"
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: {
                        click: function($event) {
                          return _vm.markDone()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("support.registrationDetails.markdone")
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.correspondingTab === "pending"
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: {
                        click: function($event) {
                          return _vm.proceedInstallation()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t(
                              "support.registrationDetails.proceedinstallation"
                            )
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.registration.duplicates
          ? _c("div", { staticClass: "ct-action" }, [
              _c("div", { staticClass: "ct-row two-elements" }, [
                _c("div", [
                  _c("label", { attrs: { for: "sendMail" } }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("support.registrationDetails.sendNotice"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sendMail,
                          expression: "sendMail"
                        }
                      ],
                      attrs: {
                        name: "sendMail",
                        type: "checkbox",
                        id: "sendMail"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.sendMail)
                          ? _vm._i(_vm.sendMail, null) > -1
                          : _vm.sendMail
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.sendMail,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.sendMail = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.sendMail = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.sendMail = $$c
                          }
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: {
                        click: function($event) {
                          return _vm.isDuplicate()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("support.registrationDetails.isDuplicate")
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    on: {
                      click: function($event) {
                        return _vm.noDuplicate()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("support.registrationDetails.noDuplicate")
                        ) +
                        "\n                "
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("duplicates")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ct-action" }, [
      _c("div", { staticClass: "ct-row two-elements" }, [_c("div")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-214a147a", { render: render, staticRenderFns: staticRenderFns })
  }
}